import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { Carrier } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CarrierService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/carrier',
      httpClient,
      httpFactory
    );
  }

  getCarriers(): Observable<Carrier[]> {
    return this.httpClient.get<Carrier[]>(`${this.route}`);
  }

  createCarrier(carrierName: string) {
    return this.httpClient.post(`${this.route}`, { carrierName });
  }
}
